import { Link } from "react-router-dom";
import { Phone, PhoneCall, Smartphone, Printer, Mail, MapPin, Globe, ArrowUpRight } from "lucide-react";
import { COMPANY, CONTACT, NAV_LINKS, SERVICES } from "../../data/content";
import { Logo } from "../Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="grain bg-navy text-white">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo light />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
              {COMPANY.name} is a global aviation consultancy and a division of{" "}
              {COMPANY.parent}, advancing safety, compliance, operations, security and AI
              transformation across commercial and public-sector aviation.
            </p>
            <Link
              to="/quote"
              data-testid="footer-quote-cta"
              className="mt-8 inline-flex items-center gap-1.5 rounded-full bg-aero px-6 py-3 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
            >
              Start a Conversation <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white/40">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-white/70 transition-colors hover:text-aero"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white/40">Services</h4>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services#${s.slug}`}
                    className="text-sm text-white/70 transition-colors hover:text-aero"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white/40">Contact</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-3"><Phone className="mt-0.5 h-4 w-4 text-aero" /><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone">{CONTACT.phone}</a></li>
              <li className="flex items-start gap-3"><PhoneCall className="mt-0.5 h-4 w-4 text-aero" /><span>Toll Free: {CONTACT.tollFree}</span></li>
              <li className="flex items-start gap-3"><Smartphone className="mt-0.5 h-4 w-4 text-aero" /><span>Mobile: {CONTACT.mobile}</span></li>
              <li className="flex items-start gap-3"><Printer className="mt-0.5 h-4 w-4 text-aero" /><span>E-Fax: {CONTACT.eFax}</span></li>
              <li className="flex items-start gap-3"><Mail className="mt-0.5 h-4 w-4 text-aero" /><a href={`mailto:${CONTACT.email}`} data-testid="footer-email">{CONTACT.email}</a></li>
              <li className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 text-aero" /><span>{CONTACT.address}</span></li>
              <li className="flex items-start gap-3"><Globe className="mt-0.5 h-4 w-4 text-aero" /><span>{COMPANY.website}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {COMPANY.name}. A division of {COMPANY.parent}.</p>
          <p>Global aviation consulting · Commercial & public-sector.</p>
        </div>
      </div>
    </footer>
  );
};
